export default Object.freeze({
  list: [],
  descriptions: {},
});
